import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { tk } from "@/i18n";

const ON = { email: tk("same email"), phone: tk("same phone"), linkedin: tk("same LinkedIn") };

export function DuplicateWarning({ email, phone, linkedin, onOpen }) {
  const { t } = useI18n();
  const [dups, setDups] = useState([]);
  useEffect(() => {
    const h = setTimeout(() => {
      if (!(email?.includes("@") || (phone || "").replace(/\D/g, "").length >= 6 || /linkedin\.com\/in\//i.test(linkedin || ""))) { setDups([]); return; }
      api.post("/candidates/duplicates", { email: email || null, phone: phone || null, linkedin_url: linkedin || null }).then((r) => setDups(r.data)).catch(() => setDups([]));
    }, 600);
    return () => clearTimeout(h);
  }, [email, phone, linkedin]);
  if (!dups.length) return null;
  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50 dark:bg-amber-950/40 p-3 text-xs space-y-1.5" data-testid="duplicate-warning">
      <div className="flex items-center gap-1.5 font-semibold text-amber-800 dark:text-amber-300"><AlertTriangle className="w-4 h-4" />{t("This candidate may already exist ({{count}})", { count: dups.length })}</div>
      {dups.map((d, i) => (
        <div key={d.id} className="flex items-center gap-2" data-testid={`duplicate-${i}`}>
          <span className="flex-1 min-w-0 truncate"><b>{d.full_name}</b>{d.current_title ? ` · ${d.current_title}` : ""}{d.current_company ? ` · ${d.current_company}` : ""} <span className="text-muted-foreground">({d.matched_on.map((m) => t(ON[m])).join(", ")})</span></span>
          {onOpen && <button type="button" onClick={() => onOpen(d)} className="text-primary underline shrink-0" data-testid={`duplicate-open-${i}`}>{t("View profile")}</button>}
        </div>
      ))}
      <p className="text-muted-foreground">{t("You can still add this candidate if it is a different person.")}</p>
    </div>
  );
}
